import { GlobalActions } from '@ps20-frontend/shop-integration-redux';
import { delay, put, select, takeLeading } from 'redux-saga/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { App } from '@ps20-frontend/frontend-models';
import { IAppState } from '../toolbarState';
import { ToolbarActions } from '../toolbar.actions';

export function* watchGesamtpreisInfo() {
  yield takeLeading(
    GlobalActions.GESAMTPREIS_CHANGED,
    safeSaga(gesamtpreisInfoSaga, App.SHOP_TOOLBAR),
  );
}

export function* gesamtpreisInfoSaga() {
  const state: IAppState = yield select();
  if (state.gesamtpreisPopover.gesamtpreisInfoChanged) {
    yield delay(2500);
    yield put(new ToolbarActions().gesamtpreisPopupOpenChanged(false));
  }
}
